export enum ReportsActionTypes {
  DOWNLOAD_INCIDENTS_REPORT_REQUEST = 'DOWNLOAD_INCIDENTS_REPORT_REQUEST',
  DOWNLOAD_INCIDENTS_REPORT_END = 'DOWNLOAD_INCIDENTS_REPORT_END',

  DOWNLOAD_ROUTES_POINTS_REPORT_REQUEST = 'DOWNLOAD_ROUTES_POINTS_REPORT_REQUEST',
  DOWNLOAD_ROUTES_POINTS_REPORT_END = 'DOWNLOAD_ROUTES_POINTS_REPORT_END',
}
